module.exports = __webpack_public_path__ + "img/TXT-SOCIAL-SLACK.3c2f2e43.png";